import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import AreasPage from "@/pages/AreasPage";
import InitiativesPage from "@/pages/InitiativesPage";
import InitiativeDetailPage from "@/pages/InitiativeDetailPage";
import PartnersPage from "@/pages/PartnersPage";
import ResourcesPage from "@/pages/ResourcesPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/practice" element={<AreasPage />} />
            <Route path="/focus" element={<AreasPage />} />
            <Route path="/initiatives" element={<InitiativesPage />} />
            <Route path="/initiatives/:slug" element={<InitiativeDetailPage />} />
            <Route path="/partners" element={<PartnersPage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </Layout>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
